import copyJson from '../../../demo/fixtures/w4/copy.json'
import rulesJson from '../../../demo/fixtures/w3/rules.json'
import type { ScopeDimension } from '../../../demo/types'
import { EmptyState, GlossaryText, Icon, type IconName } from '../../../ui'
import styles from './ScopePane.module.css'

interface CopyFixture { title: string; hint: string; cols: string[]; lockedBid: string; lockedCompliance: string; foot: string; empty: { title: string; sub: string } }
interface RulesFixture { checkHourLabel: string; nextCheckLabel: string }
const copy = (copyJson as unknown as { scopeTab: CopyFixture }).scopeTab
const rules = rulesJson as unknown as RulesFixture

interface ScopePaneProps {
  items: ScopeDimension[]
  enabled: Record<string, boolean>
  onEnabledChange: (key: string, enabled: boolean) => void
  onToast: (message: string) => void
}

export function ScopePane({ items, enabled, onEnabledChange, onToast }: ScopePaneProps) {
  if (!items.length) return <EmptyState className={styles.empty} data-scope="ap-scope-table" icon="target" title={copy.empty.title} text={copy.empty.sub} />
  const toggle = (item: ScopeDimension) => {
    const next = !(enabled[item.key] ?? true)
    onEnabledChange(item.key, next)
    onToast(`已${next ? '开启' : '关闭'} AI 对『${item.label}』的调整`)
  }
  return <div className={styles.pane} data-scope="ap-scope-table">
    <div className={styles.heading}><p>{copy.title.replace('{n}', String(items.length))}</p><span>{copy.hint}</span></div>
    <table className={styles.table}><thead><tr>{copy.cols.map((col) => <th key={col}>{col}</th>)}</tr></thead><tbody>{items.map((item) => <tr key={item.key}>
      <td><span className={styles.dimension}><i><Icon name={item.icon as IconName} size={13} /></i><GlossaryText text={item.label} /></span></td>
      <td><span className={`${styles.chip} ${styles[item.tone]}`}><GlossaryText text={item.state} /></span></td>
      <td className={styles.muted}><GlossaryText text={item.lastAction} /></td>
      <td className={`${styles.number} ${item.tone === 'good' ? styles.yieldGood : ''}`}><GlossaryText text={item.yieldLabel} /></td>
      <td>{item.toggle === 'on' ? <button aria-checked={enabled[item.key] ?? true} aria-label={`允许 AI 调整：${item.label}`} className={`${styles.switch} ${(enabled[item.key] ?? true) ? styles.on : ''}`} role="switch" type="button" onClick={() => toggle(item)}><span /></button> : <span aria-disabled="true" className={`${styles.chip} ${styles.lock}`}><GlossaryText text={item.toggle === 'locked-off' ? copy.lockedBid : copy.lockedCompliance} /></span>}</td>
    </tr>)}</tbody></table>
    <p className={styles.foot}><GlossaryText text={copy.foot.replace('{hour}', rules.checkHourLabel).replace('{next}', rules.nextCheckLabel)} /></p>
  </div>
}
